/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

/**
 endpoints to schedule messages
    ScheduleEmail: [POST] /api/schedule/email
    ScheduleIVR: [POST]/api/schedule/ivr
    ScheduleSMS: [POST] /api/schedule/sms
    ListScheduleEmail: [POST] /api/schedule/email/list
    ListScheduleIVR: [POST] /api/schedule/ivr/list
    ListScheduleSMS: [POST] /api/schedule/sms/list
    DeleteScheduleEmail: [DELETE] /api/schedule/email/delete/{id}
    DeleteScheduleIVR: [DELETE] /api/schedule/ivr/delete/{id}
    DeleteScheduleSMS: [DELETE] /api/sms/schedule/delete/{id}
 */
const EmailApi = {
  public: {},
  private: {
    /**
     *  To create a new automated message (schedule)
     */
    schedule: payload => ProtectedHttpClient.post(`/schedule`, payload),
    /**
     *  To fetch all schduled email
     */
    fetchScheduledList: payload => ProtectedHttpClient.post(`/schedule/list`, payload),
    /**
     *  To edit an automated email (schedule)
     */
    updateScheduledEmail: payload => ProtectedHttpClient.post(`/schedule/email`, payload),
    /**
     *  To delete an automated email (schedule)
     */
    deleteScheduledEmail: id => ProtectedHttpClient.delete(`/schedule/delete/${id}`),
    /**
     *  To toggle pause of an automated email (schedule)
     */
    togglePause: (id, payload) => ProtectedHttpClient.put(`/schedule/pause/${id}`, payload)
  }
};
export default EmailApi;
